import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { NotificationService } from 'app/_services/notification.service';
import { SessionsService } from 'app/_services/sessions.service';
import { SiteFormValidationService } from 'app/_services/site-form-validation-service';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SiteFormTableModalComponent } from './site-forms-table/site-form-table-modal.component';

@Component({
  selector: 'site-form-entry-modal',
  templateUrl: './site-form-entry-modal.component.html',
})
export class SiteFormEntryModalComponent implements OnInit {
  @Input() workOrder: any;
  @Input() formType: string;
  public modalActive: boolean = true;

  public siteForm: any;
  public formData: any[];
  private userSession: any;


  public isLoading: boolean = true;
  public saveInProgress = false;
  public answers = {};

  public validationErrors: any[] = [];

  public selectedDocumentsArray = {};

  constructor(
    private siteFormsService: SiteFormsService,
    private sessionsService: SessionsService,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private notificationService: NotificationService,
    private validationService: SiteFormValidationService,
    public globals: Globals,
  ) {}

  ngOnInit(): void {
    this.getSiteFormVersion();
  }

  private getSiteFormVersion(){
    let formId = this.workOrder.checkOffSiteFormId;
    if(this.formType=== 'checkOn'){
      formId = this.workOrder.checkOnSiteFormId;
    }
    this.siteFormsService.getSiteForm(formId).subscribe(response => {
      this.siteForm = response;
      this.formData = response.data;
      this.isLoading = false;
    });
    this.sessionsService.getLatestOwnerUserSessionForWorkOrder(this.workOrder.id).subscribe(response => {
      this.userSession = response.body;
    });
  }

  public onEditTableRow(fieldIndex: number, rowIndex: number) {
    if (!this.answers[fieldIndex]) {
      this.answers[fieldIndex] = [];
    }

    if (!this.answers[fieldIndex][rowIndex]) {
      this.answers[fieldIndex][rowIndex] = {};
    }

    this.modalActive = false;

    const modalOptions: NgbModalOptions = { centered: true, size: 'lg' };
    const modal = this.modalService.open(SiteFormTableModalComponent , modalOptions);
    modal.componentInstance.tableData = this.formData[fieldIndex].fields;
    modal.componentInstance.originalAnswers = this.answers[fieldIndex][rowIndex];
    modal.componentInstance.fieldIndex = fieldIndex;
    modal.componentInstance.rowIndex = rowIndex;

    modal.result.then((answers) => {
        this.answers[fieldIndex][rowIndex] = answers;
        this.modalActive = true;
      },(reason) => {
        if (reason.delete) {
          this.answers[fieldIndex].splice(rowIndex, 1);
        }
        this.modalActive = true;
      });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public submitForm() {
    this.saveInProgress = true;
    this.validationErrors = this.validationService.validateForm(this.answers, this.formData, this.selectedDocumentsArray);

    if (this.validationErrors.length) {
      this.saveInProgress = false;
      return
    }

    const allUploadsToProcess = Object.keys(this.selectedDocumentsArray);
    const requests = allUploadsToProcess.map(index =>
      this.siteFormsService.submitDocumentUploadForFormResponse(this.selectedDocumentsArray[index])
        .pipe(tap(fileNames => {
          this.answers[index] = fileNames;
        }),
        catchError(error => {
          this.saveInProgress = false;
          return throwError(error);
        }))
      );

    // if no uploads to make, need to return an observable anyway
    const observable = requests.length ? forkJoin(requests) : of([]);

    observable.subscribe(uploadResults => {
      let body = {
        siteFormVersionId: this.siteForm.versionId,
        formResponseData: JSON.stringify(this.answers),
        userSessionId: this.userSession.id,
        byProxy: true,
      };

      this.siteFormsService.submitFormResponse(body).subscribe(() => {
        this.activeModal.close('refresh');
        this.saveInProgress = false;
        this.notificationService.notify('success', 'Site Form Response Saved');

      }, error => {
        console.error(error);
        this.saveInProgress = false;
        this.notificationService.notify('danger', 'Site Form Response Could not Be Saved');
      });
    });
  }

  public getErrorByKey(key: number) {
    const error = this.validationErrors.find(item => item.key === key);
    return error ? true : false;
  }

  public setCheckboxValue(i, key, value) {
    if (!this.answers[i]) {
      this.answers[i] = [];
    }
    // remove the key just touched
    this.answers[i] = this.answers[i].filter(element => (element !== key));
    // if checkbox is checked, add the key just touched
    if (value) {
      this.answers[i].push(key);
    }
  }

  public onFileChange(event, answerIndex) {
    this.selectedDocumentsArray[answerIndex] = [];

    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.selectedDocumentsArray[answerIndex].push(file);
    }

    if (this.selectedDocumentsArray[answerIndex].length === 0) {
      delete this.selectedDocumentsArray[answerIndex];
    }
  }
}
